module.exports = __webpack_public_path__ + "media/dashboard/assets/images/assistents/receptionist-6c992105f781bbb6e099e31549235d1e.png";